/**
 * Forage Markets thesis copy — the Market Intelligence panel's tiles, question and framing.
 *
 * Shared rather than duplicated: this same text renders in the PRF Research tab and at the top
 * of the generated PDF report, and a reader who checks one against the other should find them
 * identical. The per-tile explanations live in App.js's METRIC_INFO under the `key` below and
 * open in the app-wide MetricInfoModal (§9).
 */

export const THESIS_TILES = [
  {
    key: "thesis_entry_forage",
    label: "Entry Strategy",
    value: "Pasture basis",
  },
  {
    key: "thesis_demand_forage",
    label: "Demand Driver",
    value: "Forage yield · PRF subsidy",
  },
  {
    key: "thesis_program_forage",
    label: "Program Role",
    value: "Subsidy capture · 51–59%",
  },
  { key: "thesis_hold_forage", label: "Target Hold", value: "10+ years" },
];

export const THESIS_QUESTION =
  "Where can grazing or hay ground be acquired such that forage income plus the federally " +
  "subsidised PRF transfer produces the highest annual yield per dollar of land — and where " +
  "does the rainfall index actually track the forage risk it is meant to hedge?";

export const THESIS_BODY = [
  [
    "What it uncovers",
    "Grids where pasture is cheap relative to what it grows and the PRF subsidy is largest per dollar deployed. The model screens on subsidy per dollar of land rather than per acre, because the two rank almost inversely — and it screens against the high-rate trap, since the highest-rate grids are dry precisely because they grow the least.",
  ],
  [
    "Investment strategy",
    "Buy deeded pasture or hay ground, insure it at the optimized coverage level and interval allocation, and hold. Where a parcel spans a county line, buy the high-CBV side — 46% of multi-county grids carry a CBV gap, median +22%, for identical rainfall at an identical rate. Where it spans a grid line, elect the better grid for all contiguous acres.",
  ],
  [
    "Dimensions",
    "Nine fixed dimensions covering subsidy yield, forage productivity, land basis, hedge quality, CBV boundary capture, water and drought resilience, cattle market access, federal grazing, and operating friction. All nine are scored — a full 100/100 weight pool. Rate mispricing was tested and retired: RMA prices the index efficiently, so the return is the subsidy transfer rather than an arbitrage. The goal is not the highest rate but where cheap land, real forage, and a hedge that actually works align.",
  ],
];
